//=================================================
//    summary: DCP 親子條款視窗 -- Hook
//              Parent Consent Letter
//              Important Information for Parents
//              ParentLetter
//
//    remarks: 000 Tim 2021/11/05 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssPCLWindow from './PCLWindow.module.scss'

import {LoadingMask, PackageVariablesLibs, GlobalLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false
// #endregion Member Variables


const COMP_NAME = "PCLWindow"

function PCLWindow(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 同意
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ConsentOnTapHandler()
    {
        console.log(COMP_NAME + ".ConsentOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "PCLConsentOnTap"
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of ConsentOnTapHandler

    /*===========================================
    summary: 點選 返回
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function BackOnTapHandler()
    {
        console.log(COMP_NAME + ".BackOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": "PCLBackOnTap"
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of BackOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: Iframe 讀取完畢
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function IframeOnLoaded()
    {
        console.log(COMP_NAME + ".IframeOnLoaded")

        // Close Loading mask        
        CloseLoadingMask()
    } // end of IframeOnLoaded
    // #endregion Other EventHandler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask
    // #endregion LoadingMask and Alert Functions

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        // Open Loading mask with message
        OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadOpenWeb)
    } // end of PaintedMe

    /*===========================================
    summary: 取得 親子條款 Url
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function GetPCLUrl()
    {
        let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)

        let strTargetDomain = window.location.protocol + "//" + window.location.hostname
        strTargetDomain = encodeURIComponent(strTargetDomain)

        let strQueryString = "TargetDomain=" + strTargetDomain
        strQueryString = strQueryString + "&Env=" + intEnv
        strQueryString = strQueryString + "&CalledBySys=DCP"

        let strUrl = PackageVariablesLibs.SysConfig.PCLUrl + "?" + strQueryString

        return strUrl
    } // end of GetPCLUrl
    // #endregion Other Functions

    // #region Render元件
    /*===========================================
    summary: 返回上一頁按鈕 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentBackButton()
    {   
        return(
            <div className={cssPCLWindow.btnBack} onClick={() => BackOnTapHandler()}>
                {window.gAppUI.BTN_Back}
            </div>
        )
    } // end of ComponentBackButton

    /*===========================================
    summary: 同意按鈕 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentConsentButton()
    {   
        return(
            <div className={cssPCLWindow.btnConsent} onClick={() => ConsentOnTapHandler()}>
                {window.gAppUI.BTN_Consent}
            </div>
        )
    } // end of ComponentConsentButton

    /*===========================================
    summary: 標題 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentTitle()
    {   
        return(
            <div className={cssPCLWindow.divTitle}>
                {window.gAppUI.LBL_ImportantInformationForParents}
            </div>
        )
    } // end of ComponentTitle

    /*===========================================
    summary: 背景 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentBG()
    {   
        return(
            <>
                <div className={cssPCLWindow.divBG}/>
                <div className={cssPCLWindow.divMask}/>
            </>
        )
    } // end of ComponentBG
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render iFrame Content 的顯示
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function RenderIFrameContentWrapper()
    {
        let strPCLUrl = GetPCLUrl()

        return (
            <div className={cssPCLWindow.divIFrameArea}>
                <div className={cssPCLWindow.divIFrameSubArea}>
                    <iframe title="IframeWebSite" 
                        onLoad={IframeOnLoaded} 
                        className={cssPCLWindow.iframeWebSite} 
                        src={strPCLUrl}/>
                </div>
            </div>
        )
    } // end of RenderIFrameContentWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <div className={cssPCLWindow.divContent}>
                <ComponentTitle />
                
                {RenderIFrameContentWrapper()}

                <ComponentConsentButton />
                <ComponentBackButton />
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssPCLWindow.divMain}>
                <ComponentBG />

                {RenderContentWrapper()}

                <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default PCLWindow